import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams} from "react-router-dom";
import {getPreviewById, getProductByName} from "../../services/ProductRepository";
import 'react-slideshow-image/dist/styles.css'
import {FaCheck} from "react-icons/fa";
import {useError} from "../../hooks/useError";
import Header from "../../components/navigation/Header";
import {VscOpenPreview} from "react-icons/vsc";
import {ChapterNavigationBar} from "../../components/navigation/ChapterNavigationBar";

export function StoreProduct() {
    const [course, setCourse] = useState(null);
    const [product, setProduct] = useState(null);
    const [tokens, setTokens] = useState([]);
    const [testCount, setTestCount] = useState(0);
    const [taskCount, setTaskCount] = useState(0);
    const [termCount, setTermCount] = useState(0);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [modules, setModules] = useState([]);
    const [selectedToken, setSelectedToken] = useState(null);
    const [tokenWithMostFeatures, setTokenWithMostFeatures] = useState(null);
    const {setErrorMessage} = useError();
    const params = useParams();

    useEffect(() => {
        getProductByName(params.productName).then(response => {
            setProduct(response)
            getPreviewById(response.id, setErrorMessage).then(result => {
                setCourse(result.course);
                setTokens(result.tokens);
                setSelectedToken(result.tokens[result.tokens.length - 1])
                setTokenWithMostFeatures(result.tokens.reduce((max, item) =>
                    item.content.split(",").length > max.content.split(",").length ? item : max
                ))
                setTestCount(result.questionCount);
                setTaskCount(result.taskCount);
                setTermCount(result.termCount);
                setRelatedProducts(result.relatedProducts)
                setPreviewImages(result.previewImages);
                setModules(result.modules);
            }).catch((error) => console.log(error));
        })


    }, [params.productName]);

    function getChapterCount() {
        let sum = 0;
        for (let i = 0; i < modules.length; i++) {
            sum += modules[i].chapters.length;
        }
        return sum;
    }

    if (product != null && selectedToken != null) {
        return (
            <div className={""}>
                <Header></Header>
                <div>
                    <div className={"hero"} >
                        <div className={"container"}>
                            <div className={"row "}>
                                <div className={"col hero-text"}>
                                    <h1 className={"display-5"}>{product.name}</h1>
                                    <h5>{product.courseCode}</h5>
                                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots
                                        in a piece of classical Latin literature from 45 BC, making it over 2000 years
                                        old</p>
                                    <Link to={`/course/preview/${product.courseCode}`} className={"btn btn-light clickable"}>
                                        <i className="bi bi-play-fill"></i>
                                        <label className={"ms-2"}>Prøv kurset</label>
                                    </Link>
                                </div>
                                <div className={"col-3 "}>
                                    <table className={" text-white table-features"} >
                                        <tbody>
                                        <tr>
                                            <td>Kapitler</td>
                                            <td>{getChapterCount()}</td>
                                        </tr>
                                        <tr>
                                            <td>Quiz spørsmål</td>
                                            <td>{testCount}</td>
                                        </tr>
                                        <tr>
                                            <td>Oppgaver</td>
                                            <td>{taskCount}</td>
                                        </tr>
                                        <tr>
                                            <td>Flashcard</td>
                                            <td>{termCount}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>


                            </div>

                        </div>
                    </div>

                    <div className={"bg-light"}>
                        <div className={"container  py-5"}>
                            <div className={"row"}>
                                <div className={"col"}>


                                    <h5 className={"fw-bold mt-5"}>Beskrivelse</h5>
                                    {
                                        product.description.split("\n").map(paragraph => (
                                            <p className={""}>{paragraph}</p>
                                        ))
                                    }


                                </div>

                            </div>
                        </div>
                    </div>

                    <div className={""}>
                        <div className={"container py-5"}>

                            <div className={"row"}>
                                <div className={"col"}>
                                    <video autoPlay={true} loop={true} preload={"auto"}
                                           className={"w-100 rounded border"}
                                           muted>

                                        <source src={"https://d3gwul1nugimfc.cloudfront.net/images/d7f0c3dfe34bab3aa00d15ba5034b4769d1bb752d2633e6689f240d29214991a.mp4"} type="video/mp4"/>
                                        Nettleseren din støtter ikke filtypen

                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"bg-light"}>
                        <div className={"container py-5"}>

                            <div className={"row"}>

                                <div className={"col"}>
                                    <table className={" table-numeric-lightblue"}>
                                        <thead>
                                        <tr>
                                            <th>Innhold</th>
                                            {
                                                tokens.map(token => (
                                                    <th>{token.name}</th>
                                                ))
                                            }
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            tokenWithMostFeatures.content.split(",").map((feature, idx) => (
                                                <tr>
                                                    <td>
                                                        <p className={""}>{feature}</p>
                                                    </td>

                                                    {
                                                        tokens.map(token => (
                                                            <td className={"text-center"}>
                                                                {
                                                                    token.content.split(",").includes(feature) ?
                                                                        <FaCheck size={12} className={"text-success"}/>

                                                                        : null

                                                                }
                                                            </td>
                                                        ))
                                                    }


                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </table>
                                    <div className={" d-flex flex-column justify-content-center align-items-center my-5"}>
                                        <div className={"btn-group mb-2 mt-4 border"}>
                                            {
                                                tokens.map((token, index) => (
                                                    <button type={"button"}
                                                            onClick={() => setSelectedToken(token)}
                                                            className={("btn " + (token === selectedToken ? "btn-dark" : "btn-light"))}>
                                                        {token.name}
                                                    </button>
                                                ))
                                            }

                                        </div>
                                        <h2 className={"fw-bold mb-3 mt-3"}>{selectedToken.price / 100} NOK / måned</h2>


                                        <Link to={"/purchase/" + selectedToken.id} className={"text-decoration-none "} data-testid={"vipps-kjop"}>
                                            <vipps-mobilepay-button
                                                type="button"
                                                brand="vipps"
                                                language="no"
                                                variant="primary"
                                                rounded="true"
                                                verb="buy"
                                                stretched="false"
                                                branded="true"
                                                loading="false"></vipps-mobilepay-button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className={""}>
                        <div className={"container py-5"}>
                            <div className={"row"}>
                                <div className={"col"}>


                                    <h5 className={"fw-bold mt-5"}>Kursets oppbygning</h5>

                                    <ChapterNavigationBar courseContent={modules} courseId={product.courseCode} preview={true}/>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )

    }
}